import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { Euro } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

export const BottomNav = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const path = location.pathname.split("/")[1];
	const currentTab = ["consumption", "budget", "tips"].includes(path)
		? path
		: "consumption";

	const handleTabChange = (value: string) => {
		navigate(`/${value}`);
	};

	return (
		<div
			className="fixed top-0 left-0 right-0 bg-white z-10 py-2 px-2"
			style={{ zIndex: 1000 }}
		>
			<div className="max-w-sm mx-auto mt-[8px]">
				<Tabs value={currentTab} onValueChange={handleTabChange}>
					<TabsList className="flex justify-between bg-gray-100 rounded-xl p-1 w-full">
						<TabsTrigger
							value="consumption"
							className={cn(
								"flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs transition-all",
								"data-[state=active]:bg-[#E6007E] data-[state=active]:text-white",
								"text-gray-700 hover:bg-gray-200",
							)}
						>
							<svg
								className="w-5 h-5 sm:w-6 sm:h-6"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<title>Ma conso</title>
								<path
									d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
							Ma conso
						</TabsTrigger>

						<TabsTrigger
							value="budget"
							className={cn(
								"flex items-center gap-1 px-3 py-1.5 rounded-md text-xs transition-all",
								"data-[state=active]:bg-[#E6007E] data-[state=active]:text-white",
								"text-gray-700 hover:bg-gray-200",
							)}
						>
							<Euro className="w-4 h-4" />
							Mes dépenses
						</TabsTrigger>

						<TabsTrigger
							value="tips"
							className={cn(
								"flex items-center gap-1 px-3 py-1.5 rounded-md text-xs transition-all",
								"data-[state=active]:bg-[#E6007E] data-[state=active]:text-white",
								"text-gray-700 hover:bg-gray-200",
							)}
						>
							<svg
								className="w-5 h-5 sm:w-6 sm:h-6"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<title>Astuces</title>
								<circle
									cx="12"
									cy="12"
									r="10"
									stroke="currentColor"
									strokeWidth="2"
								/>
								<path
									d="M12 16V17M12 7V13"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
								/>
							</svg>
							Astuces
						</TabsTrigger>
					</TabsList>
				</Tabs>
			</div>
		</div>
	);
};
